import { render, staticRenderFns } from "./sigUp.vue?vue&type=template&id=b2909eea&scoped=true&"
import script from "./sigUp.vue?vue&type=script&lang=js&"
export * from "./sigUp.vue?vue&type=script&lang=js&"
import style0 from "./sigUp.vue?vue&type=style&index=0&id=b2909eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2909eea",
  null
  
)

export default component.exports